import { filter } from "lodash";
import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import TableColumnOrder from "../TableColumnOrder";
import Tooltips from "../../Custom Components/tooltip";
import { DeleteTractorETAData } from "../../../services/tractorEtaDataService";
import { toast } from "react-toastify";
import DeleteModal from "../DeleteModal";
import { DeleteAggregateETAData } from "../../../services/aggregateEtaService";

function TractorEtaActionCenter({
  date,
  setDate,
  setShowDailyPlanUploader,
  dataExportHandler,
  type,
  allColumns,
  getToggleHideAllColumnsProps,
  filteredUserAccessData,
  globalFilter,
  setGlobalFilter,
  selectedFlatRows,
  tractorETATemplateDownloader,
  aggregateETATemplateDownloader,
  tableData,
  setNoDataState
}) {
  const [modalShow, setModalShow] = useState(false);
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [ids, setIds] = useState("")
	const [deleteMsg, setDeleteMsg] = useState([]);

  var allowToUpload = filter(filteredUserAccessData, { Upload: 1 }).length > 0;
  var allowToDownload =
    filter(filteredUserAccessData, { DownLoad: 1 }).length > 0;
  var allowToDelete = filter(filteredUserAccessData, { Delete: 1 }).length > 0;

  useEffect(()=>{
    if(type === "TractorETA"){
      var deleteList = "";
      for (let i = 0; i < selectedFlatRows.length; i++) {
        if (i !== selectedFlatRows.length - 1) {
          deleteList += selectedFlatRows[i].original.TractorETAId + ",";
        } else {
          deleteList += selectedFlatRows[i].original.TractorETAId;
        }
        setIds(deleteList);
      }
    }
    if(type === "AggregateETA"){
      var deleteListAggregate = "";
      for (let i = 0; i < selectedFlatRows.length; i++) {
        if (i !== selectedFlatRows.length - 1) {
          deleteListAggregate += selectedFlatRows[i].original.AggregateETAId + ",";
        } else {
          deleteListAggregate += selectedFlatRows[i].original.AggregateETAId;
        }
        setIds(deleteListAggregate);
      }
    }
  },[selectedFlatRows, type])

  const deletePlan = async () => {
    if(type === "TractorETA"){
      let datas = [];
      try {
        const response = await DeleteTractorETAData({
          _id: ids,
          _isTractorETAData: "No",
        });
        datas.push(response.data.Message);
        setShowDeleteModal({status : true, msg : response.data.Message});
        setDeleteMsg(datas);
      } catch (error) {
        toast.error('Unable to  delete records...please try again')
      }
    }
    if(type === "AggregateETA"){
      let datas = [];
      try {
        const response = await DeleteAggregateETAData({
          _id: ids,
          _isAggregateETAData: "No",
        });
        datas.push(response.data.Message);
        setShowDeleteModal({status : true, msg : response.data.Message});
        setDeleteMsg(datas);
      } catch (error) {
        toast.error('Unable to  delete records...please try again')
      }
    }
  };

  return (
    <>
      {showDeleteModal && (
        <DeleteModal
          showModal={showDeleteModal}
          hide={() => setShowDeleteModal(false)}
          label="delete TractorETA"
          // dataType="TractorETA"
          type={type}
          tableData={tableData}
          datas={deleteMsg}
          ids={ids}
          setNoDataState={setNoDataState}
        />
      )}
      {modalShow && (
        <TableColumnOrder
          allColumns={allColumns}
          getToggleHideAllColumnsProps={getToggleHideAllColumnsProps}
          show={modalShow}
          onHide={() => setModalShow(false)}
        />
      )}
      <div className="flex-row-align-center">
        <Form.Control
          value={globalFilter || ""}
          onChange={(e) => setGlobalFilter(e.target.value)}
          className="hiden-inp"
          placeholder="search here.."
          style={{ width: "auto" }}
        />
        <>
          <div
            style={{
              display: "flex",
              width: "200px",
              alignItems: "center",
              marginLeft: "10px",
            }}
          >
            <strong>From-</strong>
            <Form.Control
              type="date"
              value={date.fromdate}
              onChange={(e) => {
                if (e.target.value <= date.todate) {
                  setDate({ ...date, fromdate: e.target.value });
                } else {
                  setDate({ ...date, fromdate: date.fromdate });
                  alert("From date should not greater than To date.");
                }
              }}
              name="fromDate"
            />
          </div>
          <div
            style={{
              display: "flex",
              width: "200px",
              alignItems: "center",
              marginLeft: "10px",
            }}
          >
            <strong>To-</strong>
            <Form.Control
              type="date"
              value={date.todate}
              onChange={(e) => {
                if (e.target.value >= date.fromdate) {
                  setDate({ ...date, todate: e.target.value });
                } else {
                  setDate({ ...date, todate: date.todate });
                  alert("To date should not lesser than From date.");
                }
              }}
              name="toDate"
            />
          </div>
        </>
        {allowToUpload && (
          <Tooltips content={"Upload Plan"} direction="down">
            <button
              type="button"
              className="tractorActionCenter__upload"
              onClick={() => setShowDailyPlanUploader(true)}
            >
              <i class="bx bx-upload"></i>
            </button>
          </Tooltips>
        )}
        {allowToDownload && (
          <Tooltips content={"Export"} direction="down">
            <button
              type="button"
              className="tractorActionCenter__upload"
              onClick={() => dataExportHandler()}
            >
              <svg
                viewBox="0 0 512 512"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                fill="#000000"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  strokeLinejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <g
                    id="Page-1"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                  >
                    <g
                      id="Combined-Shape"
                      fill="#ffffff"
                      transform="translate(64.000000, 48.915055)"
                    >
                      <path d="M170.666667,36.418278 L170.666667,79.0849447 L42.6666667,79.0849447 L42.6666667,356.418278 L341.333333,356.418278 L341.333333,228.418278 L384,228.418278 L384,399.084945 L0,399.084945 L0,36.418278 L170.666667,36.418278 Z M313.751611,0 L414.169889,100.418278 L313.751611,200.836556 L283.581722,170.666667 L332.485,121.751 L277.333333,121.751611 C243.249474,121.751611 215.388568,148.395237 213.441977,181.991125 L213.333333,185.751611 L213.333333,292.418278 L170.666667,292.418278 L170.666667,185.751611 C170.666667,128.391511 215.942543,81.6061582 272.706355,79.1834943 L277.333333,79.0849447 L332.484,79.084 L283.581722,30.1698893 L313.751611,0 Z"></path>
                    </g>
                  </g>
                </g>
              </svg>
            </button>
          </Tooltips>
        )}
        <Tooltips content={"Download Template"} direction="down">
          <button
            type="button"
            className="tractorActionCenter__upload"
            onClick={() => {
              
                tractorETATemplateDownloader();
              }}
          >
            <i class="bx bx-download"></i>
          </button>
        </Tooltips>
       

        {allowToDelete && (
          <Tooltips content={"Delete Plan"} direction="down">
            <button
              className="tractorActionCenter__delete"
              variant="danger"
              onClick={deletePlan}
              id="tractorBulkDelete"
              disabled={selectedFlatRows.length === 0?true:false}
            >
              <i class="bx bxs-trash"></i>
            </button>
          </Tooltips>
        )}

        <Tooltips content={"Column Filter"} direction="down">
          <button
            className="tableColumnFilter_btn "
            onClick={() => setModalShow(true)}
          >
            <i class="bx bx-columns tableColumnFilter"></i>
          </button>
        </Tooltips>
      </div>
    </>
  );
}

export default TractorEtaActionCenter;
